class FactsSlider {
    constructor(element) {
        this.slider = element;
        this.wrapper = this.slider.closest('.facts-slider-wrapper');
        this.controlsContainer = this.slider.closest('.facts-wrapper').querySelector('.facts-slider-controls');
        this.dotsContainer = this.controlsContainer ? this.controlsContainer.querySelector('[data-facts-dots]') : null;
        this.prevButton = this.controlsContainer ? this.controlsContainer.querySelector('[data-facts-prev]') : null;
        this.nextButton = this.controlsContainer ? this.controlsContainer.querySelector('[data-facts-next]') : null;
        this.slides = Array.from(this.slider.querySelectorAll('.col'));
        this.currentSlide = 0;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.isDragging = false;
        
        this.init();
    }
    
    init() {
        if (this.slider.classList.contains('facts-slider-initialized')) {
            console.log('Facts Slider: Already initialized, skipping');
            return;
        }
        this.slider.classList.add('facts-slider-initialized');
        
        this.createDots();
        this.attachEventListeners();
        this.updateSlider();
    }
    
    createDots() {
        console.log('createDots: Starting');
        console.log('createDots: dotsContainer', this.dotsContainer);
        console.log('createDots: slides count', this.slides.length);
        
        if (!this.dotsContainer) {
            console.error('createDots: No dots container found!');
            return;
        }
        
        this.dotsContainer.innerHTML = '';
        
        this.slides.forEach((_, index) => {
            const dot = document.createElement('button');
            dot.classList.add('facts-slider-dot');
            dot.setAttribute('aria-label', `Zu Fakt ${index + 1} wechseln`);
            
            if (index === 0) {
                dot.classList.add('active');
            }
            
            dot.addEventListener('click', () => {
                this.goToSlide(index);
            });
            
            this.dotsContainer.appendChild(dot);
            console.log(`createDots: Created dot ${index + 1}`);
        });
        
        console.log('createDots: Finished, total dots:', this.dotsContainer.children.length);
    }
    
    attachEventListeners() {
        if (this.prevButton) {
            this.prevButton.addEventListener('click', () => this.prevSlide());
        }
        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => this.nextSlide());
        }
        
        this.slider.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
        this.slider.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: true });
        this.slider.addEventListener('touchend', () => this.handleTouchEnd());
        
        this.slider.addEventListener('mousedown', (e) => this.handleMouseDown(e));
        this.slider.addEventListener('mousemove', (e) => this.handleMouseMove(e));
        this.slider.addEventListener('mouseup', () => this.handleMouseUp());
        this.slider.addEventListener('mouseleave', () => this.handleMouseUp());
        
        document.addEventListener('keydown', (e) => {
            if (window.innerWidth >= 768) return;
            
            if (e.key === 'ArrowLeft') {
                this.prevSlide();
            } else if (e.key === 'ArrowRight') {
                this.nextSlide();
            }
        });
        
        window.addEventListener('resize', () => this.handleResize());
    }
    
    handleTouchStart(e) {
        this.touchStartX = e.touches[0].clientX;
    }
    
    handleTouchMove(e) {
        this.touchEndX = e.touches[0].clientX;
    }
    
    handleTouchEnd() {
        if (!this.touchStartX || !this.touchEndX) return;
        
        const difference = this.touchStartX - this.touchEndX;
        const threshold = 50;
        
        if (Math.abs(difference) > threshold) {
            if (difference > 0) {
                this.nextSlide();
            } else {
                this.prevSlide();
            }
        }
        
        this.touchStartX = 0;
        this.touchEndX = 0;
    }
    
    handleMouseDown(e) {
        this.isDragging = true;
        this.touchStartX = e.clientX;
        this.slider.style.cursor = 'grabbing';
    }
    
    handleMouseMove(e) {
        if (!this.isDragging) return;
        this.touchEndX = e.clientX;
    }
    
    handleMouseUp() {
        if (!this.isDragging) return;
        
        this.isDragging = false;
        this.slider.style.cursor = 'grab';
        
        if (!this.touchStartX || !this.touchEndX) return;
        
        const difference = this.touchStartX - this.touchEndX;
        const threshold = 50;
        
        if (Math.abs(difference) > threshold) {
            if (difference > 0) {
                this.nextSlide();
            } else {
                this.prevSlide();
            }
        }
        
        this.touchStartX = 0;
        this.touchEndX = 0;
    }
    
    handleResize() {
        if (window.innerWidth >= 768) {
            this.slider.style.transform = 'none';
        } else {
            this.updateSlider();
        }
    }
    
    goToSlide(index) {
        if (index < 0 || index >= this.slides.length) return;
        
        this.currentSlide = index;
        this.updateSlider();
    }
    
    nextSlide() {
        if (this.currentSlide < this.slides.length - 1) {
            this.currentSlide++;
            this.updateSlider();
        }
    }
    
    prevSlide() {
        if (this.currentSlide > 0) {
            this.currentSlide--;
            this.updateSlider();
        }
    }
    
    updateSlider() {
        if (window.innerWidth >= 768) return;
        
        // Berechnung für 50% Breite der Karten
        const slideWidth = this.slides[0].offsetWidth;
        const gap = 16;
        const offset = -(this.currentSlide * (slideWidth + gap));
        
        this.slider.style.transform = `translateX(${offset}px)`;
        
        if (this.dotsContainer) {
            const dots = this.dotsContainer.querySelectorAll('.facts-slider-dot');
            dots.forEach((dot, index) => {
                if (index === this.currentSlide) {
                    dot.classList.add('active');
                } else {
                    dot.classList.remove('active');
                }
            });
        }
        
        if (this.prevButton) {
            this.prevButton.disabled = this.currentSlide === 0;
        }
        if (this.nextButton) {
            this.nextButton.disabled = this.currentSlide === this.slides.length - 1;
        }
    }
}

function initFactsSliders() {
    console.log('Facts Slider: Initializing');
    const sliders = document.querySelectorAll('[data-facts-slider]');
    console.log('Facts Slider: Found sliders:', sliders.length);
    
    sliders.forEach((slider, index) => {
        console.log(`Facts Slider ${index}: Initializing`);
        new FactsSlider(slider);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFactsSliders);
} else {
    initFactsSliders();
}

window.addEventListener('load', () => {
    const sliders = document.querySelectorAll('[data-facts-slider]');
    if (sliders.length > 0 && !sliders[0].classList.contains('facts-slider-initialized')) {
        console.log('Facts Slider: Initializing on window load');
        initFactsSliders();
    }
});